import '../css/landingpage.scss';
import "open-iconic/font/css/open-iconic-bootstrap.scss";
import "../../fonts/style.scss";

import {AudioPlayer} from "./Components/AudioPlayer";
import {FeedbackSurvey} from "./Components/FeedbackSurvey";

window.player = new AudioPlayer();
window.survey = new FeedbackSurvey();
